{
  "page": {
    "intro": "店舗と保管庫に実際にある在庫を、場所・状態・持ち主ごとに表示します。数字を直接書き換えることはできず、変更には必ず理由を入力します。",
    "receive": "入荷する",
    "tabs": "在庫の見方",
    "tab_levels": "商品と場所ごと",
    "tab_cards": "カード1枚ごと",
    "levels_hint": "行をタップすると履歴と在庫の変更。シングルカードはカード一覧が開きます。",
    "cards_hint": "カード1枚につき1行。タップして履歴を見る・販売停止・紛失／破損にする。",
    "one_product": "1つの商品だけを表示中です。",
    "show_all": "すべて表示"
  },
  "states": {
    "draft": "まだ販売前",
    "available": "販売中",
    "held": "取り置き中（購入手続き中）",
    "reserved": "確保中（支払い待ち）",
    "sold": "売約済み",
    "fulfilled": "発送・お渡し済み",
    "returned": "返品 — 要確認",
    "withdrawn": "販売停止",
    "consignment_returned": "委託者に返却済み",
    "lost": "紛失",
    "damaged": "破損"
  },
  "owner": {
    "shop": "店",
    "consignor": "委託品",
    "mixed": "店＋委託"
  },
  "columns": {
    "title": "商品",
    "code": "商品コード",
    "condition": "状態",
    "state": "ステータス",
    "location": "場所",
    "owner": "持ち主",
    "hold": "取り置き期限",
    "cost": "仕入価格",
    "agreed_price": "委託の合意価格",
    "received_at": "入荷日",
    "listed_at": "販売開始",
    "sold_at": "販売日",
    "updated": "最終変更"
  },
  "levels": {
    "on_hand": "棚にある",
    "reserved": "取り置き・確保",
    "unsellable": "確認待ち",
    "available": "販売できる",
    "incoming": "移動中",
    "holds": "取り置き"
  },
  "filters": {
    "code": "商品コード",
    "sold_out": "売り切れ",
    "has_hold": "取り置きあり",
    "kind": "種類",
    "on_hold": "取り置き・確保中（残り時間つき）",
    "age": "在庫期間",
    "age_90": "90日以上"
  },
  "views": {
    "sold_out": "売り切れ",
    "with_holds": "取り置きあり",
    "sealed": "未開封商品",
    "on_hold": "取り置き・確保中",
    "consigned_not_listed": "委託品（未販売）",
    "old": "90日以上売れていない",
    "returned": "返品 — 要確認"
  },
  "age": {
    "days_other": "{{count}} 日"
  },
  "holds": {
    "expired": "期限切れ",
    "in_minutes": "残り {{time}}",
    "in_hours": "残り {{h}} 時間 {{m}} 分",
    "in_days": "残り {{d}} 日 {{h}} 時間",
    "no_expiry": "期限なし",
    "see_card": "カードを開いて確認",
    "intro": "誰かのために確保中のカード・商品です（ウェブの決済中、レジ、チャットのお客様など）。解除すると販売に戻ります。",
    "empty": "今、取り置きはありません。",
    "owner": {
      "cart": "ウェブのカート",
      "checkout": "ウェブの決済中",
      "order": "注文",
      "pos_order": "レジの販売",
      "register": "レジ",
      "live_show": "ライブ配信",
      "staff": "スタッフの取り置き",
      "channel_order": "マーケットの注文",
      "other": "その他"
    },
    "columns": {
      "type": "種類",
      "item": "商品",
      "owner": "確保している相手",
      "qty": "数",
      "created": "開始",
      "expires": "残り時間",
      "actions": "操作"
    },
    "release": "解除",
    "release_title": "この取り置きを解除しますか？",
    "release_consequence": "{{title}} はすぐにすべての場所で販売に戻ります。",
    "release_why": "理由",
    "release_reasons": {
      "customer_cancelled": "お客様が不要になった",
      "customer_no_show": "お客様が来なかった",
      "wrong_item": "違う商品を確保した",
      "stuck": "取り置きが残ったまま",
      "other": "その他"
    },
    "release_note": "ひとこと（履歴に残ります）",
    "release_reason_required": "解除の理由を選んでください。",
    "release_note_required": "「その他」はひとこと書いてください。",
    "released": "{{title}} を販売に戻しました",
    "released_hint": "すべての画面とウェブショップで再び販売中になります。",
    "filters": {
      "q": "検索",
      "q_placeholder": "名前または商品コード",
      "expiring": "10分以内に終わる",
      "older": "確保している期間",
      "older_24": "1日以上"
    },
    "views": {
      "expiring": "まもなく終了",
      "old": "1日以上",
      "manual": "スタッフの取り置き"
    },
    "manual": {
      "open": "お客様のために取り置き",
      "title": "お客様のために取り置き",
      "description": "期限が来るか解除されるまで、どこでも販売されなくなります。",
      "confirm": "取り置く",
      "item": "商品をスキャンまたは検索",
      "item_hint": "商品コード、カードのラベル、バーコード、名前。",
      "change_item": "別の商品を選ぶ",
      "no_card": "このカードは今販売中ではないため取り置けません。",
      "qty": "数",
      "reason": "理由",
      "reasons": {
        "chat_customer": "チャットでお客様から",
        "phone_order": "電話でお客様から",
        "event": "イベント用",
        "other": "その他"
      },
      "note": "誰のため・ひとこと",
      "note_hint": "例：田中様（LINE）、土曜に来店",
      "how_long": "期間",
      "durations": {
        "3600": "1時間",
        "86400": "1日",
        "259200": "3日",
        "604800": "7日"
      },
      "done": "{{title}} を取り置きました",
      "problem": {
        "item": "先に商品を選んでください。",
        "reason": "理由を選んでください。",
        "note": "誰のための取り置きか書いてください。",
        "qty": "1個以上にしてください。"
      }
    }
  },
  "hold_types": {
    "cart": "カートの中",
    "checkout": "オンラインで支払い中",
    "pos_hold": "レジで取り置き",
    "live_show": "ライブ配信",
    "channel_pending": "他の販売先で支払い中",
    "layaway": "分割払い",
    "manual": "スタッフが取り置き"
  },
  "unit": {
    "title": "カード",
    "cert": "鑑定番号",
    "on_hold": "このカードは取り置き中です。",
    "open_hold": "取り置きを見る",
    "history": "このカードの記録",
    "no_history": "まだありません。",
    "movements": "在庫の履歴",
    "all_movements": "すべての履歴",
    "withdraw": "販売停止",
    "withdraw_title": "このカードの販売を停止しますか？",
    "withdraw_consequence": "再開するまで、ウェブショップとレジに表示されなくなります。",
    "withdraw_done": "販売を停止しました",
    "republish": "販売を再開",
    "republish_title": "このカードの販売を再開しますか？",
    "republish_consequence": "ウェブショップとレジでまた購入できるようになります。",
    "republish_done": "販売を再開しました",
    "write_off": "紛失／破損にする",
    "return_to_consignor": "委託者に返却する"
  },
  "reasons_text": {
    "received": "入荷",
    "published": "販売開始",
    "hold_created": "取り置き",
    "hold_released": "取り置き終了",
    "hold_expired": "取り置き期限切れ",
    "sold": "販売",
    "fulfilled": "発送",
    "returned": "返品",
    "staff_decision": "スタッフの判断",
    "mark_lost": "紛失にした",
    "mark_damaged": "破損にした",
    "transfer_shipped": "別の場所へ送った",
    "transfer_received": "別の場所から届いた"
  },
  "adjust": {
    "open": "在庫を変更",
    "title_unit": "このカードを紛失／破損にする",
    "title_level": "在庫を変更する",
    "unit_hint": "シングルカードは「−1」ではなく、紛失または破損として在庫から外します。",
    "what_happened": "何があったか",
    "write_off": {
      "lost": "紛失（見つからない）",
      "damaged": "破損（販売できない）"
    },
    "confirm": "変更を保存",
    "confirm_lost": "紛失にする",
    "confirm_damaged": "破損にする",
    "done_lost": "「{{title}}」を紛失にしました",
    "done_damaged": "「{{title}}」を破損にしました",
    "done_level": "「{{title}}」: {{from}} → {{to}}",
    "qty": "増やす（+）／減らす（−）数",
    "minus": "1つ減らす",
    "plus": "1つ増やす",
    "preview": "{{place}}: 棚の数 {{from}} → {{to}}",
    "type": "変更の種類",
    "types": {
      "adjustment": "修正",
      "damage": "破損した分",
      "lost": "紛失した分"
    },
    "reason": "理由",
    "reasons": {
      "miscount": "数え間違い",
      "found": "見つかった",
      "damaged": "破損",
      "lost": "紛失",
      "theft": "盗難",
      "sample": "見本に使用",
      "other": "その他"
    },
    "note": "ひとこと",
    "note_hint": "あとで履歴を見る人の助けになります。",
    "problems": {
      "reason_required": "理由をひとことで選んでください（例: 数え間違い）。",
      "note_required": "何があったか書いてください。",
      "qty_zero": "数を選んでください（0 以外）。",
      "below_zero": "棚の数は 0 より少なくできません。"
    }
  },
  "drift": {
    "title_other": "{{count}} 件の商品で、在庫数と履歴が一致しません",
    "how_to_fix": "直し方",
    "hide": "閉じる",
    "expected_actual": "本来 {{expected}}、カウンターは {{actual}}"
  },
  "movement_types": {
    "receipt": "入荷",
    "purchase": "仕入",
    "consignment_intake": "委託受付",
    "consignment_return": "委託者へ返却",
    "sale": "販売",
    "return": "返品",
    "adjustment": "修正",
    "transfer_out": "別の場所へ移動",
    "transfer_in": "別の場所から到着",
    "damage": "破損",
    "lost": "紛失",
    "count": "棚卸し",
    "buylist_intake": "買取"
  },
  "references": {
    "order": "ウェブ注文",
    "pos_order": "レジ販売",
    "channel_order": "他の販売先の注文",
    "consignment_item": "委託カード",
    "buylist_intake": "買取",
    "stock_transfer": "移動",
    "stock_count": "棚卸し",
    "adjustment": "修正",
    "live_show": "ライブ配信",
    "receipt": "入荷",
    "purchase": "仕入",
    "hold": "取り置き",
    "catalog": "商品の変更",
    "manual": "手入力",
    "order_return": "注文の返品",
    "pos_return": "レジでの返品",
    "order_cancel": "注文キャンセル",
    "oversell_conflict": "二重販売の判断"
  },
  "actors": {
    "staff": "スタッフ",
    "system": "システム",
    "pos_device": "レジ",
    "service": "システム"
  },
  "movements": {
    "intro": "在庫の変更をすべて新しい順に表示します。履歴は編集できません。",
    "counted_item": "数量管理の商品",
    "columns": {
      "when": "日時",
      "product": "商品",
      "type": "内容",
      "delta": "増減",
      "after": "変更後の棚の数",
      "reference": "理由のもと",
      "actor": "担当"
    },
    "filters": {
      "code": "商品",
      "code_placeholder": "商品コード・JAN・鑑定番号",
      "dates": "期間",
      "actor": "スタッフ（ID）"
    }
  },
  "receive": {
    "intro": "場所を選び、商品を順番にスキャン（Enter で追加）して「入荷する」を押します。",
    "form_label": "入荷",
    "consigned_note": "委託カードは委託受付で入荷します（本人確認と古物台帳はそちらで行います）。",
    "consigned_link": "委託受付を開く",
    "location": "入れる場所",
    "reference_type": "入手先",
    "reference_purchase": "仕入先から購入",
    "reference_manual": "その他",
    "reference_id": "伝票・請求書番号",
    "reference_id_hint": "任意 — あとで探しやすくなります。",
    "scan": "商品をスキャンまたは入力",
    "scan_hint": "商品コード・JAN・鑑定番号 + Enter。Ctrl/⌘ + Enter で入荷。",
    "added": "追加: {{title}}",
    "duplicate_card": "{{code}} はすでにリストにあります — シングルカードは常に1点です。",
    "empty": "まだスキャンしていません",
    "empty_hint": "最初の商品をスキャン — 次のスキャンのために入力欄はそのままです。",
    "lines": "入荷する商品",
    "qty": "数",
    "qty_of": "{{title}} の数",
    "single_hint": "シングルカードは1点",
    "cost": "仕入価格（1点）",
    "cost_of": "{{title}} の仕入価格",
    "remove": "{{title}} を外す",
    "note": "メモ",
    "summary": "{{lines}} 行 · {{pieces}} 点",
    "submit": "入荷する",
    "done": "入荷しました: {{lines}} 行・{{pieces}} 点",
    "no_lines": "先に商品を1つ以上スキャンしてください。",
    "no_location": "入れる場所を選んでください。",
    "recent": "最近の入荷",
    "no_receipts": "まだ入荷はありません。",
    "receipt_title": "入荷記録",
    "receipt_missing": "この入荷記録は見つかりませんでした。",
    "pieces_other": "{{count}} 点"
  },
  "scan": {
    "hint": "コードをスキャンまたは入力して Enter。名前を入力して選ぶこともできます。",
    "looking": "コードを確認中…",
    "not_found": "コード「{{code}}」の商品はありません。",
    "lookup_failed": "コードを確認できませんでした — 接続を確認してください。",
    "camera_open": "カメラを使う",
    "camera_close": "カメラを閉じる",
    "camera_on": "バーコードにカメラを向けてください",
    "camera_failed": "カメラを開けませんでした。ブラウザでカメラを許可するか、スキャナーを使ってください。"
  },
  "locations": {
    "intro": "在庫を置く店舗と倉庫です。在庫が残っていない場所だけ使用をやめられます。",
    "add": "場所を追加",
    "new_title": "新しい場所",
    "drawer_hint": "在庫を置く場所です。オンライン注文は発送できる場所から出荷されます。",
    "save": "場所を保存",
    "saved": "{{code}} を保存しました",
    "duplicate": "このコードはほかの場所で使われています。",
    "activate": "また使う",
    "activate_title": "{{code}} をまた使いますか？",
    "activate_consequence": "また在庫を受け入れられるようになります。",
    "activated": "{{code}} をまた使います",
    "deactivate": "使用をやめる",
    "deactivate_title": "{{code}} の使用をやめますか？",
    "deactivate_consequence": "一覧に表示されなくなります。履歴は残ります。",
    "deactivated": "{{code}} の使用をやめました",
    "checking_stock": "残っている在庫を確認中…",
    "cannot_deactivate": "この場所にはまだ在庫があります",
    "has_stock": "まだ {{count}} 点あります。先に別の場所へ移動（移動）してください。",
    "has_stock_many": "まだ {{count}} 点以上あります。先に別の場所へ移動（移動）してください。",
    "is_default": "ここはメインの場所です。先に別の場所をメインにしてください。",
    "ok": "OK",
    "in_use": "使用中",
    "not_in_use": "未使用",
    "columns": {
      "name": "名前",
      "use": "用途",
      "active": "使用中"
    },
    "fields": {
      "code": "コード",
      "code_hint": "大文字・数字・-（例: TOKYO-STORE）。",
      "code_locked": "コードは変更できません（ラベルと履歴で使われています）。",
      "name_en": "名前（英語）",
      "name_ja": "名前（日本語）",
      "name_th": "名前（タイ語）",
      "type": "場所の種類",
      "address": "住所",
      "phone": "電話番号"
    },
    "address": {
      "postal_code": "郵便番号",
      "prefecture": "都道府県",
      "city": "市区町村",
      "address1": "番地",
      "address2": "建物名・階"
    },
    "types": {
      "store": "店舗",
      "warehouse": "倉庫",
      "vault": "金庫・保管庫",
      "virtual": "実在しない場所"
    },
    "flags": {
      "fulfillsOnline": "オンライン注文を発送",
      "fulfillsOnline_hint": "ここからウェブ注文を梱包できます。",
      "pickupEnabled": "店頭受け取りができる",
      "pickupEnabled_hint": "購入手続きで受け取り場所として表示されます。",
      "isDefault": "メインの場所",
      "isDefault_hint": "ほかを選ばない限り、入荷や新しいカードはここに入ります。"
    },
    "problems": {
      "required": "入力してください。",
      "code_format": "大文字 A–Z・数字・- を使ってください（2〜32文字、先頭は文字）。"
    }
  },
  "transfers": {
    "intro": "店舗と保管庫のあいだで在庫を2段階で移動します: 送る（移動中）→ スキャンして受け取る。",
    "new": "新しい移動",
    "status_filter": "表示",
    "status": {
      "draft": "下書き",
      "in_transit": "移動中",
      "received": "受け取り済み",
      "cancelled": "取り消し"
    },
    "empty": "まだ移動はありません",
    "empty_hint": "「新しい移動」で在庫を別の場所へ動かします。",
    "to": "から",
    "pieces_other": "{{count}} 点",
    "has_missing": "足りないものがあります",
    "title_of": "移動 {{from}} → {{to}}",
    "from": "送り元",
    "to_label": "送り先",
    "same_location": "別々の場所を選んでください。",
    "scan": "送るものをスキャンまたは入力",
    "scan_hint": "カードはラベルのコード、BOX・パックは JAN（1回スキャン = 1点追加）。",
    "duplicate": "{{code}} はすでにリストにあります。",
    "no_lines": "まだ何も入っていません",
    "no_lines_hint": "最初の商品をスキャンしてください。",
    "lines": "商品",
    "note": "メモ",
    "save_draft": "下書き保存",
    "saved": "移動を保存しました",
    "ship": "今すぐ送る",
    "ship_title": "この移動を送りますか？",
    "ship_consequence": "{{count}} 点が今 {{from}} から出て、{{to}} で受け取るまで「移動中」になります。その間は販売できません。",
    "shipped": "送りました: {{count}} 点が移動中",
    "shipped_at": "送った日時",
    "received_at": "受け取り",
    "cancel": "移動を取り消す",
    "cancel_title": "この移動を取り消しますか？",
    "cancel_consequence": "何も動きません。下書きは閉じられます。",
    "print": "移動伝票を印刷",
    "receive": "受け取る（スキャン）",
    "receive_title": "{{to}} で受け取る",
    "receive_intro": "出てきたカードや BOX をすべてスキャンします。緑 = 到着。",
    "not_in_transit": "この移動は移動中ではありません。",
    "receive_progress": "{{done}} / {{total}} 到着",
    "scan_in": "届いたものをスキャン",
    "scan_result": {
      "card": "到着: {{title}}",
      "counted": "到着: {{title}}（{{total}}）",
      "duplicate": "スキャン済み: {{title}}",
      "too_many": "送った数より多い: {{title}}",
      "not_in_transfer": "この移動に含まれていません: {{title}}"
    },
    "arrived": "到着",
    "waiting": "未スキャン",
    "sent": "送った数",
    "difference": "差",
    "save_progress": "ここまでの到着を保存",
    "progress_saved": "保存しました — あとで続けられます",
    "finish": "受け取りを終える",
    "missing_title_other": "{{count}} 点が届いていません",
    "missing_consequence": "差として残ります。もう一度探すか、あとで紛失として確定してください。",
    "missing_reason": "何があったか",
    "missing_reason_hint": "例: 袋に入っていなかった。",
    "finish_anyway": "差があるまま終える",
    "received_done": "受け取りました",
    "missing_other": "{{count}} 点不足",
    "confirmed_lost_other": "{{count}} 点を紛失として確定",
    "confirm_lost": "紛失として確定",
    "confirm_lost_title": "紛失として確定しますか？",
    "confirm_lost_consequence": "{{title}} × {{count}} を紛失として在庫から外します（履歴に残ります）。",
    "lost_confirmed": "紛失として確定しました"
  },
  "counts": {
    "intro": "スキャナーかカメラで、1つの場所の在庫を数えます。数えている間も販売は続けられます。",
    "start": "棚卸しを始める",
    "start_title": "棚卸しを始める",
    "start_hint": "今あるはずの在庫を記録してから、見つけたものをすべてスキャンします。",
    "scope": "数える範囲",
    "scope_all": "この場所のすべて",
    "scope_productType": "一部の種類だけ",
    "shelf": "棚・箱（任意）",
    "shelf_hint": "自分用のメモ（例: ショーケース2）。",
    "note": "メモ",
    "status_filter": "表示",
    "status": {
      "open": "開始",
      "counting": "カウント中",
      "review": "差の確認中",
      "closed": "完了",
      "cancelled": "取り消し"
    },
    "empty": "まだ棚卸しはありません",
    "empty_hint": "「棚卸しを始める」を押して、棚のものをすべてスキャンします。",
    "scan_title": "カウント中",
    "leave_scan": "終了",
    "not_editable": "この棚卸しは終わっています — スキャンはできません。",
    "progress": "{{counted}} / {{expected}} カウント済み",
    "scan_label": "スキャン",
    "scan_hint": "入力欄はそのままなので、続けてスキャンしてください。手入力のときは Enter。",
    "feedback": {
      "none": "最初の商品をスキャンしてください。",
      "card": "カウントしました",
      "sealed": "カウントしました（{{total}}）",
      "duplicate": "カウント済み — このカードは前にスキャンしました",
      "unresolved": "このコードを確認中…"
    },
    "offline_other": "接続なし — {{count}} 件のスキャンをこのタブレットに保存し、あとで送ります",
    "sending_other": "{{count}} 件のスキャンを送信中…",
    "all_sent": "すべて保存済み",
    "unknown_title_other": "{{count}} 件のコードは当店の商品ではありません",
    "unknown_hint": "別にしておき、あとで調べてください。",
    "missing_title_other": "まだ見つかっていない: {{count}}",
    "of_expected": "{{expected}} 中 {{counted}}",
    "still_sending": "まだ送信中のスキャンがあります。少し待ってからもう一度押してください。",
    "finish_scan": "カウントを終える",
    "summary_title": "{{place}} の棚卸し",
    "continue_scan": "スキャンを続ける",
    "totals": {
      "expected": "あるはずの数",
      "counted": "数えた数",
      "variance_lines": "差がある行",
      "moved": "カウント中に動いた"
    },
    "variance_value": "差の金額:",
    "threshold": "これを超えると店長の承認が必要",
    "review": "差を確認する",
    "cancel": "この棚卸しを取り消す",
    "cancel_title": "この棚卸しを取り消しますか？",
    "cancel_consequence": "在庫は何も変わりません。スキャンは破棄されます。",
    "differences_other": "差 {{count}} 件",
    "no_differences": "すべて一致 — 締めても何も変わりません。",
    "expected": "あるはず",
    "counted": "数えた",
    "difference": "差",
    "value": "金額",
    "apply": "修正する",
    "apply_line": "{{title}} を修正する",
    "reason_of": "{{title}} の理由",
    "result": "結果",
    "moved_after": "カウント中に販売・移動されました — 確認してください",
    "resolution": {
      "pending": "待ち",
      "no_variance": "一致",
      "adjusted": "在庫を修正",
      "rejected": "修正しない",
      "skipped_moved": "スキップ（移動済み）"
    },
    "needs_manager": "差の金額が店の上限を超えています — 店長が締めてください。",
    "close": "締めて在庫を修正",
    "close_title": "棚卸しを締めて在庫を修正しますか？",
    "close_consequence_other": "差 {{count}} 件が在庫の修正になります（履歴に残ります）。",
    "close_note": "理由",
    "close_note_hint": "すべての修正と一緒に保存されます。",
    "default_note": "棚卸し",
    "closed_done_other": "棚卸しを締めました — 修正 {{count}} 件",
    "back_to_scan": "スキャンに戻る",
    "see_movements": "在庫の履歴で修正を見る"
  }
}
